import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

import { API } from 'aws-amplify';
// import axios from 'axios';

import { 
    AppBar, 
    Button, 
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Container, 
    Grid,
    Paper, 
    Table, 
    TableBody, 
    TableCell, 
    TableHead, 
    TableRow, 
    Toolbar, 
    Typography, } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
// import PhoneAndroidIcon from '@material-ui/icons/PhoneAndroid';
// import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';

import RegisterProduct from './RegisterProduct';
import WarrantyClaim from './WarrantyClaim';

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.primary,
      marginTop: theme.spacing(9),
    },
  },
  logo: {
      width: '200px',
      height: '50px',
  },
  paper: {
    height: theme.spacing(55),
  },
  register: {
        color: theme.palette.text.secondary,
        position: 'relative',
        float: 'left',
        // top: '50%',
        left: '50%',
        transform: 'translate(-50%, 0%)',
        fontSize: '6rem',
  },
}));

export default function Home(props) {
    const { t } = useTranslation();
    const classes = useStyles();

    const [claimDetails, setClaimDetails] = useState(undefined);
    const [deviceManufacturers, setDeviceManufacturers] = useState([]);
    const [warrantyClaim, setWarrantyClaim] = useState(false);
    const [userDetails, setUserDetails] = useState(undefined);
    const [isLoading, setIsLoading] = useState(true);

    const [registerProduct, setRegisterProduct] = useState(false);

    useEffect(() => {
        async function getCurrentUserDetails(){
            try {
                const userDetails = await API.get('CrystalusionAPI', '/user');
                setUserDetails(userDetails);
                setIsLoading(false);
                const deviceManufacturers = await API.get('CrystalusionAPI', '/device/Manufacturer');
                deviceManufacturers.push({Manufacturer: "Manufacturer", Metadata: t('ManufacturerNotListed')})
                
                setDeviceManufacturers(deviceManufacturers.map(manufacturer => (manufacturer.Metadata)))
            } catch(error) {
                console.log(error);
                setUserDetails({Address: {Line1:"", Line2:"", City:"", Postcode:"", Country:""},Devices: [], WarrantyClaims: []})
                setIsLoading(false);
                const deviceManufacturers = await API.get('CrystalusionAPI', '/device/Manufacturer');
                deviceManufacturers.push({Manufacturer: "Manufacturer", Metadata: t('ManufacturerNotListed')})

                setDeviceManufacturers(deviceManufacturers.map(manufacturer => (manufacturer.Metadata)))
            }
        };

        getCurrentUserDetails();
    }, [t]);


  return (
        <>
        <AppBar color="default" >
            <Toolbar>
                {/* <Typography variant="h6" style={{flexGrow: 1}} noWrap>
                    {t('CompanyName')}
                </Typography> */}
                <div style={{flexGrow: 1}}>
                <img src={t('Logo')} alt={t('CompanyName')} className={classes.logo}/>
                </div>
                <Button onClick={props.handleLogout} color="primary" variant="outlined">
                    {t('Logout').toUpperCase()}
                </Button>
            </Toolbar>
        </AppBar>

        <Container component="main" maxWidth="lg">
            <Typography variant="h5" style={{flexGrow: 1}} noWrap>
                {t('Welcome', { name: props.user.name})}
            </Typography>

            <Typography variant="h6" color="inherit" style={{flexGrow: 1}} noWrap>
                {t('Titles.Devices')} 
            </Typography>
            <Grid container justify="flex-start" spacing={1}>
                { isLoading ? 
                    (   
                        [0, 1, 2, 3].map(value => (
                            <Grid key={value} item xs={12} md={4} lg={3}>
                                <Skeleton className={classes.paper} variant="rect"/>
                            </Grid>
                        ))
                    ) :
                    [   
                        userDetails.Devices.map(device => (
                            <Grid key={device.DeviceId} item xs={12} md={4} lg={3}>
                                <Card className={classes.paper}>
                                    <CardActionArea onClick={() => (
                                        userDetails.WarrantyClaims.find(claim => claim.WarrantyCode === device.WarrantyCode) !== undefined ?
                                        (
                                            console.log("Already Claimed")
                                        ) : (
                                            setClaimDetails({
                                                DeviceManufacturer: device.Manufacturer,
                                                DeviceModel: device.Model,
                                                DeviceId: device.DeviceId,
                                                WarrantyCode: device.WarrantyCode,
                                            }),
                                            setWarrantyClaim(true)
                                        )
                                    )}>
                                        <CardMedia
                                        component="img"
                                        alt={device.Manufacturer}
                                        height="275"
                                        image="https://cdn1.iconfinder.com/data/icons/smartphone-and-tablet-outline/100/iphone_6-512.png"
                                        title={device.Manufacturer}
                                        />
                                        <CardContent>
                                            <Typography gutterBottom variant="h5" component="h2">
                                                {
                                                    device.Nickname ? device.Nickname : device.Manufacturer+" "+device.Model
                                                }
                                            </Typography>
                                            <Typography variant="inherit" color="inherit" align="right" noWrap>
                                            {/* {new Intl.DateTimeFormat('en-GB').format(Date.parse(device.RegisteredOn))} */}
                                            {device.DeviceId}
                                        </Typography>
                                        </CardContent>
                                    </CardActionArea>
                                    <CardActions>
                                        {
                                            userDetails.WarrantyClaims.find(claim => claim.WarrantyCode === device.WarrantyCode) !== undefined ? (
                                                <Button variant="outlined" size="small" disabled>{t('Claimed')}</Button>
                                            ) : (
                                                <>
                                                    <Button variant="outlined" size="small" className={classes.protected}>{t('Protected')}</Button>
                                                    <Button variant="outlined" size="small" color="secondary" onClick={() => (
                                                        userDetails.WarrantyClaims.find(claim => claim.WarrantyCode === device.WarrantyCode) !== undefined ?
                                                        (
                                                            console.log("Already Claimed")
                                                        ) : (
                                                            setClaimDetails({
                                                                DeviceManufacturer: device.Manufacturer,
                                                                DeviceModel: device.Model,
                                                                DeviceId: device.DeviceId,
                                                                WarrantyCode: device.WarrantyCode,
                                                            }),
                                                            setWarrantyClaim(true)
                                                        )
                                                    )}>{t('MakeAClaim')}</Button>
                                                </>
                                            )
                                        }
                                        
                                    </CardActions>
                                </Card>
                            </Grid>
                        )),
                        <Grid key="RegisterCode" item xs={12} md={4} lg={3}>
                                <Card className={classes.paper} onClick={() => setRegisterProduct(true)}>
                                    <CardActionArea className={classes.paper}>
                                        <AddIcon fontSize='inherit' className={classes.register}/>
                                    </CardActionArea>
                                </Card>
                        </Grid>
                    ]
                }
            </Grid>

            <br/>
            <Typography variant="h6" color="inherit" style={{flexGrow: 1}} noWrap>
                {t('Titles.Claims')} 
            </Typography>
            <Grid>
                { isLoading ? 
                    (   
                        <Skeleton height={110} variant="rect"/>
                    ) :
                    (   
                        <Paper>
                        <Table className={classes.table} aria-label="simple table">
                            <TableHead>
                            <TableRow>
                                <TableCell>Device</TableCell>
                                <TableCell align="right">Code</TableCell>
                                <TableCell align="right">ClaimedAt</TableCell>
                                <TableCell align="right">Status</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {userDetails.WarrantyClaims.map(claim => (
                                <TableRow hover key={claim.WarrantyCode}>
                                <TableCell component="th" scope="row">
                                
                                    {claim.DeviceManufacturer+" "+claim.DeviceModel}
                                </TableCell>
                                <TableCell align="right">{claim.WarrantyCode}</TableCell>
                                <TableCell align="right">{claim.ClaimedAt}</TableCell>
                                <TableCell align="right">{claim.Status}</TableCell>
                                </TableRow>
                            ))}
                            </TableBody>
                        </Table>
                        </Paper>
                    )
                }
            </Grid>
        </Container>

        <RegisterProduct 
            deviceManufacturers={deviceManufacturers}
            registerProduct={registerProduct} 
            setRegisterProduct={setRegisterProduct}
            setUserDetails={setUserDetails}
        />

        {
            isLoading ? 
            (null) : (
                <WarrantyClaim 
                    claimDetails={claimDetails} 
                    user={props.user}
                    defaultAddress={userDetails.Address}
                    setUserDetails={setUserDetails}
                    setWarrantyClaim={setWarrantyClaim} 
                    warrantyClaim={warrantyClaim}/>
            )
        }
        </>
    )
    
}